import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ReadonlyState {
  readonly: boolean;
  caseId: number | null;
  lockedBy: number | null;
  isLocked: boolean;
  isReadOnly: boolean;
  hasFollowup?: boolean | null;
}

const initialState: ReadonlyState = {
  readonly: false,
  caseId: null,
  lockedBy: null,
  isLocked: false,
  isReadOnly: false,
  hasFollowup: false,
};

export const readonlySlice = createSlice({
  name: "readonly",
  initialState,
  reducers: {
    setReadonlyState: (
      state,
      action: PayloadAction<{
        readonly: boolean;
        caseId: number;
        lockedBy: number | null;
        isLocked: boolean;
        isReadOnly: boolean;
        hasFollowup?: boolean;
      }>
    ) => {
      const { readonly, caseId, lockedBy, isLocked, isReadOnly, hasFollowup } =
        action.payload;
      state.readonly = readonly;
      state.caseId = caseId;
      state.lockedBy = lockedBy;
      state.isLocked = isLocked;
      state.isReadOnly = isReadOnly;
      state.hasFollowup = hasFollowup;
    },
    setReadonly: (state, action: PayloadAction<boolean>) => {
      state.readonly = action.payload;
    },
    clearReadonlyState: (state) => {
      state.readonly = false;
      state.caseId = null;
      state.lockedBy = null;
      state.isLocked = false;
      state.isReadOnly = false;
      state.hasFollowup = false;
    },
  },
});

export const { setReadonlyState, setReadonly, clearReadonlyState } =
  readonlySlice.actions;
export default readonlySlice.reducer;
